import PropTypes from "prop-types"
import { useCallback, useEffect, useRef, useState } from "react"
import { useNavigate, useSearchParams } from "react-router-dom"

import api from "apis"

export default function fetchOrder(WrappedComponent) {
  const FetchOrder = ({ orderUpdateData, rmaType, validatePath, ...props }) => {
    const [data, setData] = useState(orderUpdateData)
    const [loading, setLoading] = useState(true)
    const [orderNumber, setOrderNumber] = useState("")
    const [orderToken, setOrderToken] = useState("")
    const [customerGuid, setGuid] = useState("")
    const cancelled = useRef(false)
    const [searchParams] = useSearchParams()
    const navigate = useNavigate()

    const order_number = searchParams.get("order_number")
    const customer_guid = searchParams.get("customer_guid")
    const order_token = searchParams.get("order_token")

    const getOrder = useCallback(async () => {
      if (orderNumber && (customerGuid || orderToken)) {
        const response = await api
          .post(validatePath, {
            customer_guid: customerGuid,
            order_number: orderNumber,
            order_token: orderToken,
            rma_type: rmaType,
          })
          .catch((err) => console.log(err))

        if (!cancelled.current) {
          let responseData
          if (response && response.data) {
            responseData = response.data
          } else {
            responseData = response
          }

          if (responseData && responseData.redirect_url) {
            setLoading(false)
            navigate(responseData.redirect_url)
            return
          }

          if (
            responseData &&
            (responseData.order ||
              responseData.repair_items ||
              responseData.line_items)
          ) {
            setData(responseData)
          }
          setLoading(false)
        }
      }
    }, [customerGuid, orderNumber, orderToken, rmaType])

    useEffect(() => {
      if (!cancelled.current) {
        if (order_number) {
          setOrderNumber(order_number)
        } else {
          setLoading(false)
        }
        if (order_token) {
          setOrderToken(order_token)
        }
        if (customer_guid) {
          setGuid(customer_guid)
        }
      }
    }, [order_number, order_token, customer_guid, orderUpdateData])

    useEffect(() => {
      getOrder()
    }, [getOrder])

    useEffect(() => {
      return () => (cancelled.current = true)
    }, [])

    return (
      <WrappedComponent
        data={data}
        loading={loading}
        orderNumber={orderNumber}
        {...props}
      />
    )
  }

  FetchOrder.propTypes = {
    orderUpdateData: PropTypes.object,
    rmaType: PropTypes.string,
    validatePath: PropTypes.string,
  }
  return FetchOrder
}
